<div class="membership-container">
    <form [formGroup]="form" fxLayout="column" class="p-20" fxLayoutGap="30px">
        <div fxLayout="row" fxLayoutAlign="center center">
            <span class="txt-p-16-4" >{{'Configure membership fee for the year'|i18n}} <strong>{{year}}</strong>.</span>
        </div>
        <div app-input-container fxLayout="row" fxFlex fxLayoutAlign="center center" fxLayoutGap="10px">
            <span class="txt-p-16-4" fxLayoutAlign="center center" >{{'Fee applied to each member'|i18n}}{{':*'}}</span>
            <input app-input
                   type="number"
                   formControlName="membershipFeeControl"
                   min="0"
                   max="1000"
                   step="0.01"
                   (input)="limitDecimals()"
                   fxFlex="20">
            <span class="txt-p-16-4" fxLayoutAlign="center center">{{'€'|i18n}}</span>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
            <div fxLayout="column" class="panel-3 br-10">
                <div fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center center">
                    <app-icon name="fas-info-circle" class="icon-color-t"></app-icon>
                    <div fxLayout="column">
                        <div fxLayout="row">
                            <span class="txt-s-14-4">{{'The fee will be charged on a one-time basis for each active member within the calendar year.'| i18n}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div fxLayout="row"
             fxLayoutAlign="center center"
             class="m-20"
             *ngIf="form.hasError('out_of_range_values') && form.controls.membershipFeeControl.touched" class="txt-a-16-7">
            {{'Membership fee must be positive'|i18n}}
        </div>
    </form>
</div>
